module.exports = __webpack_public_path__ + "static/table_repeating_pattern_long-6bb8813a0f5f79777d83205acd69e8b0.jpg";